import React from 'react'
import { Link } from 'react-router-dom'
import '../submitsetupform/SubmitSetupForm.css'

const SubmitSetupForm = () => {
  return (
    <div className='submit-setup-section w-100 '>
      <div className='submit-setup-box text-center d-flex flex-wrap align-content-center justify-content-center'>
        <p>We do not tolerate any <strong>bullying, harassment or assault</strong> of any kind. </p>
        <p>Should you be found to partake in any such activities, you will be<strong> immediately removed</strong> from our community. </p>
        <p>If necessary, <Link rel='stylesheet' className='link-text' to="/home"><strong>legal consequences </strong></Link>will be carried out. </p>
      </div>
    </div>
  )
}

export default SubmitSetupForm
